var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tx-density-chart bg-secondary"},[_c('div',{staticClass:"text-white-100 title"},[_vm._v("Transactions density")]),(_vm.blocks.length)?_c('div',{staticClass:"chart-container"},[_c('d3-bar-chart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions},on:{"barClick":_vm.barClick}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }